var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrizTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.321777 14.4392C0.321777 6.91852 6.41852 0.821777 13.9392 0.821777H66.7043C74.225 0.821777 80.3218 6.91852 80.3218 14.4392V43.6112C80.3218 51.1319 74.225 57.2286 66.7043 57.2286H15.8632C7.27991 57.2286 0.321777 50.2705 0.321777 41.6872V14.4392ZM13.9392 5.83514C9.18732 5.83514 5.33514 9.68732 5.33514 14.4392V41.6872C5.33514 47.5017 10.0487 52.2152 15.8632 52.2152H66.7043C71.4562 52.2152 75.3084 48.3631 75.3084 43.6112V14.4392C75.3084 9.68732 71.4562 5.83514 66.7043 5.83514H13.9392Z",
    fill: "#00A3A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3224 52.2144C41.7068 52.2144 42.829 53.3366 42.829 54.721V67.2923C42.829 68.6767 41.7068 69.799 40.3224 69.799C38.938 69.799 37.8157 68.6767 37.8157 67.2923V54.721C37.8157 53.3366 38.938 52.2144 40.3224 52.2144Z",
    fill: "#00A3A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2485 67.2918C25.2485 65.9074 26.3708 64.7852 27.7552 64.7852H52.8909C54.2754 64.7852 55.3976 65.9074 55.3976 67.2918C55.3976 68.6762 54.2754 69.7985 52.8909 69.7985H27.7552C26.3708 69.7985 25.2485 68.6762 25.2485 67.2918Z",
    fill: "#00A3A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3185 20.4621C35.4389 20.4621 31.1608 23.1247 28.9085 27.1036C28.2266 28.3084 26.6971 28.7323 25.4923 28.0503C24.2875 27.3683 23.8637 25.8388 24.5456 24.6341C27.6585 19.1347 33.5739 15.4487 40.3185 15.4487C47.0631 15.4487 52.9786 19.1347 56.0914 24.6341C56.7734 25.8388 56.3495 27.3683 55.1447 28.0503C53.94 28.7323 52.4105 28.3084 51.7285 27.1036C49.4763 23.1247 45.1982 20.4621 40.3185 20.4621Z",
    fill: "#00A3A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3144 31.6188C38.6103 31.6188 37.1428 32.5751 36.4572 33.8915C35.8177 35.1193 34.3039 35.5963 33.0761 34.9568C31.8482 34.3173 31.3713 32.8035 32.0108 31.5756C33.5606 28.6 36.7428 26.6055 40.3144 26.6055C43.8859 26.6055 47.0682 28.6 48.618 31.5756C49.2575 32.8035 48.7805 34.3173 47.5527 34.9568C46.3248 35.5963 44.8111 35.1193 44.1716 33.8915C43.4859 32.5751 42.0185 31.6188 40.3144 31.6188Z",
    fill: "#00A3A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3229 41.9906C41.9731 41.9906 43.3109 40.6528 43.3109 39.0026C43.3109 37.3524 41.9731 36.0146 40.3229 36.0146C38.6727 36.0146 37.335 37.3524 37.335 39.0026C37.335 40.6528 38.6727 41.9906 40.3229 41.9906Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrizTv);
export default __webpack_public_path__ + "static/media/BrizTv.8b40bdfd7cf584a88437afea07a5a7de.svg";
export { ForwardRef as ReactComponent };